require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./gnie-chimique-et-biotechnologie-2-2-2-4.json") })
        }
      }, "path---gnie-chimique-et-biotechnologie-2-2-2-4");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---gnie-chimique-et-biotechnologie-2-2-2-4!./.cache/json/gnie-chimique-et-biotechnologie-2-2-2-4.json
// module id = 444
// module chunks = 231608221292675